import { createContext, useContext, useState, ReactNode } from "react";

export type ListingType = "trad" | "plankor" | "ved";

export interface ListingFlowData {
  listingType: ListingType | null;
  category: string;
  subCategory: string;
  images: string[];
  title: string;
  description: string;
  species: string;
  province: string;
  municipality: string;
  woodAge: string;
  diameter: string;
  moistureContent: string;
  processingGrade: string;
  price: string;
  quantity: string;
  pickupEnabled: boolean;
  shippingEnabled: boolean;
  shippingPrice: string;
  deliveryRadiusKm: string;
  pickupAddress: string;
  plankLength: string;
  plankWidth: string;
  plankHeight: string;
}

const defaultData: ListingFlowData = {
  listingType: null,
  category: "",
  subCategory: "",
  images: [],
  title: "",
  description: "",
  species: "",
  province: "",
  municipality: "",
  woodAge: "",
  diameter: "",
  moistureContent: "",
  processingGrade: "",
  price: "",
  quantity: "",
  pickupEnabled: true,
  shippingEnabled: false,
  shippingPrice: "",
  deliveryRadiusKm: "",
  pickupAddress: "",
  plankLength: "",
  plankWidth: "",
  plankHeight: "",
};

interface ListingFlowContextType {
  data: ListingFlowData;
  updateData: (partial: Partial<ListingFlowData>) => void;
  resetData: () => void;
}

const ListingFlowContext = createContext<ListingFlowContextType | null>(null);

export function ListingFlowProvider({ children }: { children: ReactNode }) {
  const [data, setData] = useState<ListingFlowData>(defaultData);

  const updateData = (partial: Partial<ListingFlowData>) =>
    setData((prev) => ({ ...prev, ...partial }));

  const resetData = () => setData(defaultData);

  return (
    <ListingFlowContext.Provider value={{ data, updateData, resetData }}>
      {children}
    </ListingFlowContext.Provider>
  );
}

export function useListingFlow() {
  const ctx = useContext(ListingFlowContext);
  if (!ctx) throw new Error("useListingFlow must be used within ListingFlowProvider");
  return ctx;
}
